import React from "react";
import { MagazineInsert } from "@bloomberg/media-ui-article";

import { Story } from "~types/types";
import { makeRetinaSrcsets } from "~utils/makeRetinaSrcsets";

import styles from "./MagazineInsert.module.css";

interface MagazineInsertComponentProps {
    story: Story;
}

const MAX_WIDTH = 76;
const ASPECT_RATIO = 76 / 48;

const MagazineInsertComponent = ({ story }: MagazineInsertComponentProps) => {
    if (!story.magazineIssue) return null;

    const { id, displayDate, date, coverImage } = story.magazineIssue;

    if (!coverImage) return null;

    const { mobile: srcSet } = makeRetinaSrcsets({
        baseUrl: coverImage.url,
        desktopMaxWidth: MAX_WIDTH,
        mobileMaxWidth: MAX_WIDTH,
        aspectRatio: ASPECT_RATIO,
    });

    return (
        <div className={styles.magazineInsert}>
            <MagazineInsert
                issueId={id}
                date={displayDate ?? date}
                coverImage={coverImage}
                srcSet={srcSet}
            />
        </div>
    );
};

export default MagazineInsertComponent;
